import React from "react";

function LogTimeSpan({ users, onClose }) {
	return (
		<div className="fixed z-1 w-full min-h-screen overflow-y bg-[rgba(0,0,0,0.649)] left-0 top-0 flex items-center justify-center">
			<div className="text-white sm:w-8/12 md:w-6/12 lg:w-4/12 bg-[#3D3E44] rounded-xl ml-[300px] mb-[50px]">
				{/* Header for Form */}
				<div className="bg-[#9B9B9B] rounded-t-xl py-3 text-3xl text-center">
					Average Log Time Span
				</div>
				{/* Scrollable container with maximum height */}
				<div className="max-h-[300px] my-[20px] overflow-y-scroll">
					{users?.map((user, index) => (
						<div className="mb-[16px] text-white text-xl pl-4 bg-[#616675] py-3 px-2 rounded-lg flex justify-between items-center mx-[1%]">
							<div>
								{index + 1}. {user.userName}
							</div>
							<div className="bg-[#D9D9D9] rounded-full text-black px-2 py-1">
								{/* Enter the user average log time span in the whole project below :) */}
								{user.userAvgTime ? Number((user.userAvgTime).toFixed(1)) : 0}{" "}
								Hours/day
							</div>
						</div>
					))}
				</div>
				{/* Search and Close Button */}
				<div className="flex justify-around my-4 sm:my-4 mx-16">
					<button
						className="bg-[#616675] text-center px-3 py-1 rounded-lg text-xl mr-2"
						onClick={onClose}
					>
						Close
					</button>
				</div>
			</div>
		</div>
	);
}

export default LogTimeSpan;
